/* Elysian product hero (v4): size tiles and the grind chips pick the variant by option values; Dawn's product-form handles the add.
   2026-09-28, purchase choice (snippets/elysian-subscribe.liquid): Subscribe / One-time tiles and the frequency chips. One-time is
   preselected from 2026-09-29 (Chris: "It feels sneaky"); nothing here assumes either, the state is read from the checked radio.
   Real mode: the tiles are the form's selling_plan radios; Subscribe carries the chosen plan id, prices come from the variant's
   selling_plan_allocations. Review mode (no selling plans yet): the radios are outside the form, so the add is one-time; prices use
   the preview discount. Every state change is instant. */
(function () {
  function bind(root) {
    if (root.dataset.elyBound) return;
    root.dataset.elyBound = '1';
    var data = root.querySelector('[data-ely-variants]');
    var variants = data ? JSON.parse(data.textContent) : [];
    var sizePos = parseInt(root.dataset.sizePos, 10) || 0;
    var grindPos = parseInt(root.dataset.grindPos, 10) || 0;
    var idInput = root.querySelector('[data-ely-variant-id]');
    var button = root.querySelector('[data-ely-submit]');
    var label = button ? button.querySelector('span') : null;
    /* grind: chips (radios, round 2) or the select when a product has more than 6 grind values */
    var grindEls = root.querySelectorAll('[data-ely-grind]');
    function grindValue() {
      if (!grindEls.length) return null;
      if (grindEls[0].tagName === 'SELECT') return grindEls[0].value || null; /* '' = no grind chosen yet (2026-10-26) */
      var c = root.querySelector('[data-ely-grind]:checked');
      return c ? c.value : null;
    }
    var sub = root.querySelector('[data-ely-sub]');
    /* review mode never shows on the published theme (the Liquid checks theme.role too) */
    if (sub && sub.dataset.mode === 'mock' && window.Shopify && Shopify.theme && Shopify.theme.role === 'main') { sub.parentNode.removeChild(sub); sub = null; }
    var subRadio = sub ? sub.querySelector('[data-ely-purchase-subscribe]') : null;
    var frequency = sub ? sub.querySelector('[data-ely-frequency]') : null;
    function money(cents) {
      cents = Math.round(cents);
      /* thousands separator (2026-10-17: the readout can pass $1,000 with the bag stepper), as Shopify's money format prints it */
      var t = cents % 100 === 0 ? String(cents / 100) : (cents / 100).toFixed(2);
      return '$' + t.replace(/^(\d+)/, function (d) { return d.replace(/\B(?=(\d{3})+(?!\d))/g, ','); });
    }
    function subscribing() { return !!(subRadio && subRadio.checked); }

    function current() {
      var sizeEl = root.querySelector('[data-ely-size]:checked');
      var size = sizeEl ? sizeEl.value : null;
      var g = grindValue();
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (sizePos && v.options[sizePos - 1] !== size) continue;
        if (grindPos && g !== null && v.options[grindPos - 1] !== g) continue;
        return v;
      }
      return null;
    }
    function updateVariant() {
      var v = current();
      if (!button) return;
      if (!v) { button.disabled = true; if (label) label.textContent = 'Unavailable'; return; }
      if (idInput) idInput.value = v.id;
      root.dataset.variantId = v.id;
      button.disabled = !v.available;
      if (label) label.textContent = !v.available ? 'Sold Out' : (subscribing() ? (sub.dataset.button || 'Subscribe') : 'Add to Cart');
      updatePrices(v);
      updateSticky(v);
    }
    /* subscription price of a variant for the chosen plan: its selling plan allocation (real) or the preview discount (review mode) */
    function subPrices(v) {
      var plan = sub.querySelector('[data-ely-plan]:checked');
      var price = v.price, compare = v.price;
      if (sub.dataset.mode === 'real') {
        var allocs = v.selling_plan_allocations || [];
        for (var i = 0; i < allocs.length; i++) {
          if (plan && String(allocs[i].selling_plan_id) === plan.value) { price = allocs[i].price; compare = allocs[i].compare_at_price || v.price; }
        }
      } else {
        price = Math.round(v.price * (100 - (parseInt(sub.dataset.mockPct, 10) || 0)) / 100);
      }
      return { price: price, compare: compare };
    }
    /* "Ships free" star (2026-09-28): a size tile shows it when its price for the current purchase choice meets that choice's
       free-shipping threshold (section settings, cents on the section). Instant; a 150ms scale-in only when it appears after a
       switch, never on first paint (CSS drops it for reduced motion). */
    var freeOne = parseInt(root.dataset.freeOneTime, 10) || 0, freeSub = parseInt(root.dataset.freeSub, 10) || 0;
    var shipFirst = true;
    function variantFor(size) {
      var g = grindValue();
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (sizePos && v.options[sizePos - 1] !== size) continue;
        if (grindPos && g !== null && v.options[grindPos - 1] !== g) continue;
        return v;
      }
      return null;
    }
    /* one wiggle (CSS ely-shipfree-wiggle); restarting it on a repeat pick */
    function wiggle(badge) { badge.classList.remove('is-wiggle'); void badge.offsetWidth; badge.classList.add('is-wiggle'); }
    root.addEventListener('animationend', function (e) { if (e.animationName === 'ely-shipfree-wiggle') e.target.classList.remove('is-wiggle'); });
    function updateShipFree() {
      /* without a purchase choice (filter coffees) the one-time threshold applies */
      var on = !!sub && subscribing();
      root.querySelectorAll('[data-ely-size]').forEach(function (r) {
        var badge = r.parentNode.querySelector('[data-ely-shipfree]');
        var v = variantFor(r.value);
        if (!badge || !v) return;
        var price = on ? subPrices(v).price : v.price;
        var min = on ? freeSub : freeOne;
        var show = min > 0 && price >= min;
        var appears = show && badge.hidden && !shipFirst;
        badge.hidden = !show;
        if (appears) wiggle(badge);
      });
      shipFirst = false;
    }
    function updatePrices(v) {
      if (!sub || !v) return;
      var sp = subPrices(v), price = sp.price, compare = sp.compare;
      var saved = compare - price, pct = saved > 0 && compare > 0 ? Math.round(saved * 100 / compare) : 0;
      var t = sub.querySelector('[data-ely-sub-title]'), p = sub.querySelector('[data-ely-sub-price]'), o = sub.querySelector('[data-ely-onetime-price]'), s = sub.querySelector('[data-ely-sub-save]');
      if (t) t.textContent = pct > 0 ? sub.dataset.titleSave.replace('[percent]', pct) : sub.dataset.title;
      if (p) p.textContent = money(price);
      if (o) o.textContent = money(v.price);
      if (s) { s.hidden = saved <= 0; if (saved > 0) s.textContent = sub.dataset.pill.replace('[amount]', money(saved)); }
      updateDeal(v, price);
      updateShipFree();
    }
    /* 2026-10-17 (review fix #1): first-delivery offer on the Subscribe tile (snippets/elysian-subscribe.liquid). First = this plan's
       delivery price less data-deal-pct, rounded to the cent.
       2026-10-18 (round 6): the "Your order" receipt (renderReceipt, updateReadout, money2) left the product page; the tile carries the
       deal in dollars instead, the same wording as the Liquid first paint:
         line 1: first delivery price, the struck everyday price (this bag's one-time price), "first delivery";
         line 2: "Save $X today." (everyday less first) "Then $Y per delivery, every N weeks." (the chosen chip's n and unit);
         line 3: "Ships free, every time." when the plan price meets the subscription free threshold (data-free-sub), else the first
         delivery only from the free first shipment minimum (after the discount), else "Shipping $8 per delivery, free from $50."
         (the subscription rate, the next rate from its date, as the receipt had it); then the reassurance.
       2026-10-18 (round 7): line 2 is only "Save $X today."; line 3 is only the reassurance, server-rendered and static. The renewal
       sentence, the shipping notes, subRate() and everyText() are gone.
       2026-10-19 (round 8): the renewal comes back as one quiet sentence after the saving, "Then $Y every N weeks." (data-deal-renew;
       $Y = this plan's delivery price, N = the checked chip's data-every). */
    var dealPct = sub ? parseInt(sub.dataset.dealPct, 10) || 0 : 0;
    function updateDeal(v, price) {
      if (!dealPct) return;
      var d = sub.dataset, first = Math.round(price * (100 - dealPct) / 100);
      var was = money(v.price), firstM = money(first), thenM = money(price);
      var q = function (sel) { return sub.querySelector(sel); };
      var el;
      if ((el = q('[data-ely-sub-was]'))) el.textContent = was;
      if ((el = q('[data-ely-sub-first]'))) el.textContent = firstM;
      if ((el = q('[data-ely-sub-then]'))) el.textContent = (d.dealLine || '').replace('[price]', thenM);
      if ((el = q('[data-ely-sub-sr]'))) el.textContent = (d.dealSr || '').replace('[was]', was).replace('[first]', firstM).replace('[price]', thenM);
      if ((el = q('[data-ely-sub-saving]'))) el.textContent = (d.dealSave || '').replace('[saving]', money(v.price - first));
      if ((el = q('[data-ely-sub-renew]'))) {
        var chip = q('[data-ely-plan]:checked'), every = chip ? chip.getAttribute('data-every') || '' : '';
        el.hidden = !every;
        if (every) el.textContent = (d.dealRenew || '').replace('[price]', thenM).replace('[every]', every);
      }
    }
    /* 2026-10-17 (review fix #3): phone sticky buy bar (sections/elysian-product.liquid, CSS in elysian-buy-primary.css). Summary
       "2 lb · Subscribe · $44.80 first" (one bag, round 4); its button mirrors the main one and clicks it,
       so the add runs through the same form and handlers. Shown under 750 only, when the main button is out of view and the shopper
       is past it or past the size tiles. */
    var sticky = root.querySelector('[data-ely-sticky]');
    function updateSticky(v) {
      if (!sticky || !v || !button) return;
      var sum = sticky.querySelector('[data-ely-sticky-sum]'), lab = sticky.querySelector('[data-ely-sticky-label]'), sb = sticky.querySelector('[data-ely-sticky-btn]');
      var size = sizePos ? String(v.options[sizePos - 1] || '') : '';
      size = size.toUpperCase().replace(/ POUNDS?$/, ' LB').replace(/ LBS$/, ' LB').toLowerCase();
      var parts = [size], price;
      if (sub && subscribing()) {
        var y = subPrices(v).price;
        parts.push(sub.dataset.button || 'Subscribe');
        price = dealPct ? money(Math.round(y * (100 - dealPct) / 100)) + ' first' : money(y);
      } else {
        if (sub) parts.push('One-time');
        price = money(v.price);
      }
      parts.push(price);
      if (sum) sum.textContent = parts.filter(Boolean).join(' \u00b7 ');
      if (lab && label) lab.textContent = label.textContent;
      if (sb) sb.disabled = button.disabled;
    }
    if (sticky && button && window.IntersectionObserver) {
      var tilesEl = root.querySelector('.ely-size-tiles');
      var btnSeen = false, btnAbove = false, tilesAbove = false;
      var phone = window.matchMedia('(max-width: 749.98px)');
      function stickyShow() {
        var on = phone.matches && !btnSeen && (btnAbove || tilesAbove);
        sticky.classList.toggle('is-shown', on);
      }
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { btnSeen = e.isIntersecting; btnAbove = !e.isIntersecting && e.boundingClientRect.top < 0; });
        stickyShow();
      }).observe(button);
      if (tilesEl) new IntersectionObserver(function (es) {
        es.forEach(function (e) { tilesAbove = !e.isIntersecting && e.boundingClientRect.top < 0; });
        stickyShow();
      }).observe(tilesEl);
      if (phone.addEventListener) phone.addEventListener('change', stickyShow);
      sticky.querySelector('[data-ely-sticky-btn]').addEventListener('click', function () { if (!button.disabled) button.click(); });
    }
    function updatePlan() {
      if (!sub) return;
      var on = subscribing();
      if (frequency) frequency.hidden = !on;
      var plan = sub.querySelector('[data-ely-plan]:checked');
      /* real mode: the Subscribe radio is the form's selling_plan, so it carries the chosen plan */
      if (sub.dataset.mode === 'real' && subRadio && plan) subRadio.value = plan.value;
      updateVariant();
    }
    /* savings pill lift (card standard rule 9): marks a chosen size, so only a pick lifts the pill, never the preselected tile on load */
    var tiles = root.querySelector('.ely-size-tiles');
    root.querySelectorAll('[data-ely-size]').forEach(function (r) {
      r.addEventListener('change', function () {
        if (tiles && !tiles.hasAttribute('data-ely-chosen')) tiles.setAttribute('data-ely-chosen', '');
        updateVariant();
        var badge = r.parentNode.querySelector('[data-ely-shipfree]');
        if (badge && !badge.hidden) wiggle(badge);
      });
    });
    grindEls.forEach(function (el) { el.addEventListener('change', updateVariant); });
    /* keyboard ring fallback: WebKit drops :focus-visible when the arrow keys move within a radio group, so the group marks keyboard
       use itself (any key) and clears it on pointer down; the CSS shows the ring for :focus-visible or [data-ely-kbd] :focus */
    root.querySelectorAll('.ely-grind__chips, .ely-sub__options').forEach(function (chips) {
      chips.addEventListener('keydown', function () { chips.setAttribute('data-ely-kbd', ''); });
      chips.addEventListener('pointerdown', function () { chips.removeAttribute('data-ely-kbd'); });
    });
    /* Recharge's widget adds its own selling_plan fields to the form (a select and a hidden input) once the product has plans; later
       fields win, so they would override this choice. Disable every selling_plan field that is not ours, now, on change and on submit. */
    var form = subRadio && subRadio.form;
    function quietRecharge() {
      if (!form) return;
      var els = form.elements;
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (el.name === 'selling_plan' && !el.hasAttribute('data-ely-purchase-subscribe') && !el.hasAttribute('data-ely-purchase-onetime')) el.disabled = true;
      }
    }
    /* 2026-10-17 (review fix #1): a Subscribe add applies the first-delivery code (data-deal-code, GOODMORNING20) to the cart first, by
       a same-origin fetch to /discount/CODE (Shopify sets the cart's code; the redirect is not followed, so the page never changes). The
       code keeps its own limits (subscriptions only, first payment, once per customer). One-time adds never apply it. The add waits
       for the fetch at most 2.5 s, then goes ahead regardless. Capture phase on the document, so it runs before Dawn's product-form. */
    var dealCode = sub && dealPct ? (sub.dataset.dealCode || '').trim() : '';
    var dealPassing = false;
    if (form && dealCode && window.fetch) {
      document.addEventListener('submit', function (e) {
        if (e.target !== form || dealPassing || !subscribing()) return;
        e.preventDefault(); e.stopImmediatePropagation();
        var done = false;
        function go() {
          if (done) return; done = true; dealPassing = true;
          try {
            if (form.requestSubmit) form.requestSubmit();
            else { var ev = new Event('submit', { bubbles: true, cancelable: true }); if (form.dispatchEvent(ev)) form.submit(); }
          } finally { dealPassing = false; }
        }
        setTimeout(go, 2500);
        fetch('/discount/' + encodeURIComponent(dealCode), { credentials: 'same-origin', redirect: 'manual' }).then(go, go);
      }, true);
    }
    if (form) {
      quietRecharge();
      form.addEventListener('submit', quietRecharge, true);
      if (window.MutationObserver) new MutationObserver(quietRecharge).observe(form, { childList: true, subtree: true });
    }
    if (sub) {
      var options = sub.querySelector('.ely-sub__options');
      sub.querySelectorAll('[data-ely-purchase-subscribe], [data-ely-purchase-onetime]').forEach(function (r) {
        r.addEventListener('change', function () { if (options && !options.hasAttribute('data-ely-chosen')) options.setAttribute('data-ely-chosen', ''); updatePlan(); });
      });
      sub.querySelectorAll('[data-ely-plan]').forEach(function (r) { r.addEventListener('change', updatePlan); });
    }
    updatePlan();
    updateVariant();
  }
  function init() { document.querySelectorAll('[data-ely-product]').forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
